// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VOHi","col":"styles_col__2mddZ"};